var HSForm_EmailVerification = new Object();

HSForm_EmailVerification.version = "1.0.0";
HSForm_EmailVerification.$form = null;

HSForm_EmailVerification.init = function ($form) {
  this.$form = $form;

  const $emailField = $form.find('input[name="email"]');
  if (helpers.shouldDebug("hsForm")) console.log("[HSForm.EmailVerification] init", $emailField);

  const showEmailError = () => {
    $emailField.addClass("invalid error");
    const $errorBlock = $emailField.closest(".input").next(".hs-error-msgs");

    const errorHTML = `
      <ul class="no-list hs-error-msgs inputs-list custom-error" role="alert">
        <li>
          <label class="hs-error-msg hs-main-font-element">
            Please enter a different email address.
          </label>
        </li>
      </ul>
    `;

    if ($errorBlock.length <= 0) {
      $emailField.closest(".input").after(errorHTML);
    } else {
      $errorBlock.html(errorHTML);
    }
  };

  const clearEmailError = () => {
    $emailField.removeClass("invalid error");
    $emailField.closest(".input").next(".custom-error").remove();
  };

  const isEmailBlocked = (email) => {
    var _parent = HSForm;
    var $parentEl = _parent.$el;

    const emailBlocklist = $parentEl.data("blocklist").trim().split(",");
    const blockedEmailEntered = sessionStorage.getItem("blocked_email_entered");
    const isBlockedUser = emailBlocklist.includes(email) || blockedEmailEntered !== null;

    if (isBlockedUser) {
      sessionStorage.setItem("blocked_email_entered", email);

      if (helpers.shouldDebug("hsForm"))
        console.info("[HSForm.EmailVerification] blocked email entered");
      showEmailError();

      return isBlockedUser;
    }
  };

  $emailField.on("blur input", () => {
    if (isEmailBlocked($emailField.val())) {
      if (helpers.shouldDebug("hsForm"))
        console.log("[HSForm.EmailVerification] isEmailBlocked called");
      showEmailError();
    } else {
      clearEmailError();
    }
  });
};

export default HSForm_EmailVerification;
